<template>
    <!-- Masthead -->
    <header id="signup" class="masthead text-white text-center">
        <div class="overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-xl-9 mx-auto">
                <h1 class="mb-5">The Latest In Lead Gen &amp; Affiliate News</h1>
                </div>
                <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
                <form>
                    <div class="form-row">
                    <div class="col-12 col-md-9 mb-2 mb-md-0">
                        <input v-model="userEmail" type="email" class="form-control form-control-lg" placeholder="Enter your email...">
                    </div>
                    <div class="col-12 col-md-3">
                        <button @click.prevent="createSubscriber()" type="submit" class="btn btn-block btn-lg btn-success">Sign Up Now!</button>
                    </div>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { API } from 'aws-amplify';
import { createSubscriber } from '../../graphql/mutations';

export default {
    name: 'CallToActionA',
    data: function() {
        return {
            userEmail: ''
        }
    },
    methods: {
        createSubscriber() {
            const userEmail = this.userEmail;
            if (!userEmail) return;
            API.graphql({
                query: createSubscriber,
                variables: {input: {name: '', email: userEmail, subscribed: true, created: new Date().toJSON().slice(0,10)}},
            }).then(e => {
                window.location.href="/?subscribed=true";
            })
        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
